<script>
export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
    formatCurrency: {
      type: Function,
      required: true,
    },
  },
}
</script>

<template>
  <table :class="$style.priceSubTable">
    <colgroup>
      <col :class="$style.colNameWithCategory" />
      <col :class="$style.colPrice" />
      <col :class="$style.colOrigin" />
      <col :class="$style.colCost" />
      <col :class="$style.colCategory" />
    </colgroup>
    <thead>
      <tr>
        <th>項目名稱</th>
        <th :class="$style.subNumHead">售價</th>
        <th :class="$style.subNumHead">原價</th>
        <th :class="$style.subNumHead">成本</th>
        <th>適用分類</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(p, pi) in row.prices" :key="pi">
        <td>
          <div :class="$style.subNameText">{{ p.name || '—' }}</div>
        </td>
        <td :class="$style.moneyCell">{{ formatCurrency(p.price) }}</td>
        <td :class="$style.moneyCell">{{ formatCurrency(p.origin) }}</td>
        <td :class="$style.moneyCell">{{ formatCurrency(p.cost) }}</td>
        <td>
          <div :class="$style.subCategoryTagList">
            <el-tag v-for="(category, ci) in row.priceMode === 'per_category' ? p.categories || [] : []" :key="category.id || ci" size="mini" type="info" effect="plain" :class="$style.tag">
              {{ category.title || '—' }}
            </el-tag>
            <span v-if="row.priceMode !== 'per_category' || !(p.categories && p.categories.length)" :class="$style.subCategoryEmpty">—</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" module>
.priceSubTable {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
  color: #606266;
  border: solid 1px #ebeef5;

  th {
    text-align: left;
    padding: 8px 12px;
    background: #f5f7fa;
    font-weight: 500;
    color: #909399;
    border-bottom: 1px solid #ebeef5;
  }

  td {
    text-align: left;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f2f5;
    vertical-align: top;
  }

  tbody tr:nth-child(even) td {
    background: #fcfcfd;
  }

  tr:last-child td {
    border-bottom: none;
  }
}

.colNameWithCategory {
  width: auto;
}

.colPrice,
.colOrigin,
.colCost {
  width: 104px;
}

.colCategory {
  width: 360px;
}

.subNumHead {
  text-align: center !important;
  vertical-align: middle !important;
}

.moneyCell {
  text-align: center !important;
  vertical-align: middle !important;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.2px;
}

.subNameText {
  line-height: 1.35;
  word-break: break-word;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.subCategoryTagList {
  display: grid;
  grid-template-columns: repeat(auto-fill, 160px);
  gap: 4px 8px;
  justify-content: start;
  align-content: start;
  min-height: 24px;
  line-height: 1.3;
}

.tag {
  margin: 0;
  width: 160px;
  max-width: 160px;
  overflow: hidden;
}

.tag :global(.el-tag__content) {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subCategoryEmpty {
  color: #c0c4cc;
}
</style>
